import * as go from 'gojs';

import { BaseData } from 'src/containers/ProjectDiagram/types/data';
import { ModelData } from 'src/containers/ProjectDiagram/types/model';

// These have to use a strange curry'd function because typescript doesn't
// allow implicit/optional type arguments.
// ie: "Expected 4 type arguments, but got 2."

export const dataBinding =
  <Obj extends go.GraphObject, Data extends BaseData>() =>
  <
    ObjKey extends keyof Obj & string,
    DataKey extends '' | (keyof Data & string)
  >(
    targetProp: ObjKey,
    sourceProp?: DataKey,
    conv?: (
      val: DataKey extends '' ? Data : Data[Exclude<DataKey, ''>],
      targetObj: Obj
    ) => Obj[ObjKey]
  ) =>
    new go.Binding(targetProp, sourceProp, conv);

export const objectBinding =
  <Obj extends go.GraphObject, RootObj extends go.GraphObject>() =>
  <
    ObjKey extends keyof Obj & string,
    DataKey extends '' | (keyof RootObj & string)
  >(
    targetProp: ObjKey,
    sourceProp?: DataKey,
    conv?: (
      val: DataKey extends '' ? RootObj : RootObj[Exclude<DataKey, ''>],
      targetObj: Obj
    ) => Obj[ObjKey]
  ) =>
    new go.Binding(targetProp, sourceProp, conv).ofObject();

export const modelBinding =
  <Obj extends go.GraphObject, Data extends ModelData>() =>
  <
    ObjKey extends keyof Obj & string,
    DataKey extends '' | (keyof Data & string)
  >(
    targetProp: ObjKey,
    sourceProp?: DataKey,
    conv?: (
      val: DataKey extends '' ? Data : Data[Exclude<DataKey, ''>],
      targetObj: Obj
    ) => Obj[ObjKey]
  ) =>
    new go.Binding(targetProp, sourceProp, conv).ofModel();
